import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-order-history-mobile-skeleton',
  templateUrl: './order-history-mobile-skeleton.component.html',
  styleUrl: 'order-history-mobile-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgxSkeletonLoaderModule,
  ],
})
export class OrderHistoryMobileSkeletonComponent {
}
